import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译文件
import zh_CN_common from './locales/zh_CN/common.json';
import zh_CN_auth from './locales/zh_CN/auth.json';
import zh_CN_user from './locales/zh_CN/user.json';
import zh_CN_cashier from './locales/zh_CN/cashier.json';
import zh_CN_finance from './locales/zh_CN/finance.json';

import en_US_common from './locales/en_US/common.json';
import en_US_auth from './locales/en_US/auth.json';
import en_US_user from './locales/en_US/user.json';
import en_US_cashier from './locales/en_US/cashier.json';
import en_US_finance from './locales/en_US/finance.json';

import es_ES_common from './locales/es_ES/common.json';
import es_ES_auth from './locales/es_ES/auth.json';
import es_ES_user from './locales/es_ES/user.json';
import es_ES_cashier from './locales/es_ES/cashier.json';
import es_ES_finance from './locales/es_ES/finance.json';

import pt_BR_common from './locales/pt_BR/common.json';
import pt_BR_auth from './locales/pt_BR/auth.json';
import pt_BR_user from './locales/pt_BR/user.json';
import pt_BR_cashier from './locales/pt_BR/cashier.json';
import pt_BR_finance from './locales/pt_BR/finance.json';

// 配置资源
const resources = {
  zh_CN: {
    common: zh_CN_common,
    auth: zh_CN_auth,
    user: zh_CN_user,
    cashier: zh_CN_cashier,
    finance: zh_CN_finance
  },
  en_US: {
    common: en_US_common,
    auth: en_US_auth,
    user: en_US_user,
    cashier: en_US_cashier,
    finance: en_US_finance
  },
  es_ES: {
    common: es_ES_common,
    auth: es_ES_auth,
    user: es_ES_user,
    cashier: es_ES_cashier,
    finance: es_ES_finance
  },
  pt_BR: {
    common: pt_BR_common,
    auth: pt_BR_auth,
    user: pt_BR_user,
    cashier: pt_BR_cashier,
    finance: pt_BR_finance
  }
};

// 支持的语言列表
export const supportedLanguages = [
  { code: 'zh_CN', name: '中文(简体)', nativeName: '中文(简体)' },
  { code: 'en_US', name: 'English', nativeName: 'English' },
  { code: 'es_ES', name: 'Español', nativeName: 'Español' },
  { code: 'pt_BR', name: 'Português (Brasil)', nativeName: 'Português (Brasil)' }
];

// Ant Design locale 映射
export const getAntdLocale = (language: string) => {
  const localeMap: { [key: string]: any } = {
    'zh_CN': require('antd/locale/zh_CN'),
    'en_US': require('antd/locale/en_US'),
    'es_ES': require('antd/locale/es_ES'),
    'pt_BR': require('antd/locale/pt_BR')
  };

  return localeMap[language]?.default || localeMap['zh_CN'].default;
};

i18n
  // 使用语言检测器
  .use(LanguageDetector)
  // 集成 React
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    resources,
    fallbackLng: 'zh_CN', // 默认语言
    defaultNS: 'common', // 默认命名空间
    ns: ['common', 'auth', 'user', 'cashier', 'finance'], // 可用的命名空间

    detection: {
      // 语言检测顺序
      order: ['localStorage', 'navigator', 'htmlTag'],
      // 缓存用户语言选择
      caches: ['localStorage'],
      // localStorage 键名
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React 已经安全处理了
    },

    // 调试模式（生产环境应关闭）
    debug: process.env.NODE_ENV === 'development',

    // 解决命名空间未找到时的回退
    returnEmptyString: false,

    react: {
      useSuspense: false, // 禁用 Suspense，避免加载问题
    }
  });

export default i18n;
